import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MapIcon from '@mui/icons-material/Map';                    // ✅ NEW
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import './../Lease Module/CustomBottomNav.css';
import GuestLoginModal from '../../GuestLoginModal';
import { AuthContext } from '../../AuthContext/AuthContext';

// ── Base nav items (default = List tab) ────────────────────────────────────
const BASE_NAV_ITEMS = [
  { key: 'home',  icon: <HomeIcon />,               route: '/dashboard',  label: 'Home' },
  { key: 'list',  icon: <FormatListBulletedIcon />, route: '/Buy-details', label: 'List' },
  { key: 'saves', icon: <FavoriteBorderIcon />,     route: '/Buy-saves',  label: 'Saves' },
  { key: 'inbox', icon: <MailOutlineIcon />,        route: '/inboxlist',  label: 'Inbox' },
];

// ── The Map item that replaces List on the buy-details page ───────────────
const MAP_ITEM = {
  key: 'map',
  icon: <MapIcon />,
  route: '/buy-map',
  label: 'Map',
};

const CustomBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentKey, setCurrentKey] = useState('');
  const navRef = useRef(null);
  const { isGuest } = useContext(AuthContext);
  const [showGuestModal, setShowGuestModal] = useState(false);

  const guestRestrictedTabs = ['saves', 'inbox'];

  // ✅ Decide which nav list to render based on current route
  const isBuyDetailsPage = location.pathname.startsWith('/Buy-details');

  const navItems = isBuyDetailsPage
    ? BASE_NAV_ITEMS.map(item => (item.key === 'list' ? MAP_ITEM : item))
    : BASE_NAV_ITEMS;

  // ── Determine active key ────────────────────────────────────────────────
  useEffect(() => {
    // Special case: on /buy-map the active tab should be 'map'
    if (location.pathname.startsWith('/buy-map')) {
      setCurrentKey('map');
      return;
    }

    const activeItem =
      navItems.find(item => location.pathname.startsWith(item.route))?.key ||
      'home';
    setCurrentKey(activeItem);
  }, [location.pathname, navItems]);

  const handleNav = (item) => {
    if (isGuest && guestRestrictedTabs.includes(item.key)) {
      setShowGuestModal(true);
      return;
    }
    setCurrentKey(item.key);
    navigate(item.route);
  };

  // ── Move indicator ──────────────────────────────────────────────────────
  useEffect(() => {
    const current = navRef.current?.querySelector(
      `.nav-item[data-key="${currentKey}"]`
    );
    const indicator = navRef.current?.querySelector('.nav-indicator');
    if (current && indicator) {
      const { offsetLeft, offsetWidth } = current;
      indicator.style.left = `${offsetLeft + offsetWidth / 2 - 25}px`;
    }
  }, [currentKey, navItems]);

  return (
    <div className="nav-wrapper">
      <div className="nav-bar" ref={navRef}>
        {navItems.map((item) => (
          <div
            key={item.key}
            data-key={item.key}
            className={`nav-item ${currentKey === item.key ? 'nav-item-active' : ''}`}
            onClick={() => handleNav(item)}
          >
            {item.icon}
            <div className="nav-label">{item.label}</div>
          </div>
        ))}
        <div className="nav-indicator" />
      </div>

      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />
    </div>
  );
};

export default CustomBottomNav;